import { Table } from "react-bootstrap";
import { withTranslation } from "react-i18next";

function CitasEncuestadasComponent({data}){

    return (
        <Table responsive>
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Total de citas</th>
              <th>Con respuesta</th>
              <th>Sin respuesta</th>
            </tr>
          </thead>
          <tbody>
            {
              data.map((item,i)=>(
                <tr key={i}>
                  <td>{item.name}</td>
                  <td>{item.citas.length}</td>
                  <td>{item.citas.filter(el=>el.surveyAnswer).length}</td>
                  <td>{item.citas.filter(el=>!el.surveyAnswer).length}</td>
                </tr>
              ))              
            }            
          </tbody>
        </Table>
    )

}

export default withTranslation()(CitasEncuestadasComponent)